module.exports = __webpack_public_path__ + "media/A_L13.0f7c5dc5.mp3";